import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';
import { traderSchema } from './getTraders';

export const traderSiteSchema = baseObjectSchema.extend({
  traderId: z.string(),
  trader: traderSchema.optional(),
  county: z.string().optional(),
  city: z.string().optional(),
  address: z.string().optional(),
  zipCode: z.string().optional(),
  email: z.string().optional(),
  telephone1: z.string().optional(),
  telephone2: z.string().optional(),
  remarks: z.string().optional(),
  storePhoto: z.string().optional(),
  code: z.string().optional(),
  name: z.string().optional(),
  latitude: z.string().optional(),
  longitude: z.string().optional(),
  cityId: z.string().optional(),
  isBranch: z.boolean(),
  isDefault: z.boolean(),
  isHQ: z.boolean(),
  region: z.string().optional(),
  street: z.string().optional(),
  streetNumber: z.string().optional(),
  companySite: z
    .object({
      id: z.string(),
      name: z.string(),
      companyID: z.string(),
    })
    .optional(),
  vatLevelId: z.string().optional(),
  vatLevel: baseSchema.optional(),
  aadeTaxCode: z.string().optional(),
});

export const getTraderSitesSchema = z.array(traderSiteSchema);

const traderSiteWithCustomerSchema = z.object({
  traderSite: traderSiteSchema,
  customer: z.object({
    id: z.string(),
    code: z.string().optional(),
    profession: z.string().optional(),
  }),
});

export const getTraderSitesWithCustomerSchema = z.array(traderSiteWithCustomerSchema);

export const getTraderSitesWithConditionsSchema = z.array(
  baseObjectSchema.extend({
    code: z.string().optional(),
    name: z.string().optional(),
    address: z.string().optional(),
    zipCode: z.string().optional(),
    boid: z.string().optional(),
    storePhoto: z.string().optional(),
    isHQ: z.boolean().optional(),
    isBranch: z.boolean().optional(),
    city: z.string().optional(),
    telephone1: z.string().optional(),
    companySite: z
      .object({
        id: z.string(),
        name: z.string(),
        companyID: z.string(),
      })
      .optional(),
    trader: z.object({
      code: z.string().optional(),
      id: z.string(),
      name: z.string().optional(),
      taxNumber: z.string().optional(),
      address: z.string().optional(),
      zipCode: z.string().optional(),
    }),
    vatLevelId: z.string().optional(),
    vatLevel: baseSchema.optional(),
  })
);

export type GetTraderSitesResponse = z.infer<typeof getTraderSitesWithConditionsSchema>;
